import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import {
  buttonHoverStyles,
  buttonStyles,
  hostStyles,
  readSpeakerStyles,
  readSpeakerAsButtonStyles,
  theme,
} from './read-speaker.shared.styles';

const namespace = unsafeCSS(tagName('read-speaker'));

export const styles = css`
  :where(${namespace}) {
    ${hostStyles};
  }

  :where(${namespace} .read-speaker) {
    ${readSpeakerStyles};
  }

  :where(${namespace}:not([no-button]) .read-speaker) {
    ${readSpeakerAsButtonStyles};
  }

  :where(${namespace}[box-shadow='false'] .read-speaker) {
    box-shadow: unset;
  }

  :where(${namespace}) .button {
    ${buttonStyles};
  }

  @media (hover: hover) {
    :where(${namespace} .button):hover {
      ${buttonHoverStyles};
    }
  }

  :where(${namespace} .close-button),
  :where(${namespace} .settings-button) {
    scale: 1;
    translate: 0 0 0;
    visibility: visible;

    ${theme.props([
      [
        'transition',
        'close-button-transition',
        'all var(--tm-transition-duration-normal) var(--tm-transition-function-ease-out)',
      ],
    ])};
  }

  :where(${namespace} .loading .main-icon) {
    animation: rotate 1s linear infinite;
    transform-origin: center;
  }

  :where(${namespace}) :is(.init, .stopped) .close-button,
  :where(${namespace}) :is(.init, .stopped) .settings-button {
    inline-size: 0;
    inset-inline-start: 0;
    rotate: -180deg;
    scale: 0;
    visibility: hidden;
  }

  /* Hide default ReadSpeaker controls */
  :where(${namespace} .rsbtn) {
    display: none;
  }

  @keyframes rotate {
    from {
      rotate: 0deg;
    }

    to {
      rotate: 360deg;
    }
  }
`;
